import React, { FC } from 'react';
import { FeatureViewFCO, FeatureViewFCOFields } from '../../../core/types/fcoTypes';
import { ErrorBoundary } from '@tecton';
import { TimezoneContextProvider } from '../../context/TimezoneContext';

import { Jobs, FilterProvider } from '../jobs/JobsContainer';
import { JobsContextProvider } from '../jobs/JobsContext';
import { useParams } from 'react-router';
import { FlexGroup, FlexItem } from '@lithos';

interface MaterializationJobsProps {
  fco: FeatureViewFCO;
}

const FeatureViewJobs: FC<MaterializationJobsProps> = ({ fco }) => {
  const { workspace } = useParams(); // Don't use userSettings to get the workspace here since we need to be on workspace routed URL.

  // FEATURE TABLE VERSION
  if (fco[FeatureViewFCOFields.IS_MATERIALIZATION_ENABLED] && fco[FeatureViewFCOFields.IS_FEATURE_TABLE]) {
    return (
      <FlexGroup>
        <FlexItem>
          <ErrorBoundary>
            <TimezoneContextProvider>
              <JobsContextProvider feature_view={fco.name} workspace={workspace}>
                <FilterProvider isFeatureView={true}>
                  <Jobs />
                </FilterProvider>{' '}
              </JobsContextProvider>
            </TimezoneContextProvider>
          </ErrorBoundary>
        </FlexItem>
      </FlexGroup>
    );
  }

  return (
    <>
      {fco[FeatureViewFCOFields.IS_MATERIALIZATION_ENABLED] && !fco[FeatureViewFCOFields.IS_FEATURE_TABLE] && (
        <FlexGroup>
          <FlexItem>
            <ErrorBoundary>
              <TimezoneContextProvider>
                <JobsContextProvider feature_view={fco.name} workspace={workspace}>
                  <FilterProvider isFeatureView={true}>
                    <Jobs />
                  </FilterProvider>{' '}
                </JobsContextProvider>
              </TimezoneContextProvider>
            </ErrorBoundary>
          </FlexItem>
        </FlexGroup>
      )}
    </>
  );
};

export default FeatureViewJobs;
